import React from 'react';
import { useNavigate, useNavigation, useParams } from 'react-router-dom';
import Box from '@mui/material/Box/Box';
import { Button, Divider, Stack } from '@mui/material';
import Loading from '../../../components/Loading';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { downloadPDF, useBackgroundReportHTML } from '../../../Common';
import { getReport } from '../../../apis/user.api';
import { LoadingButton } from '@mui/lab';
import { useImmer } from 'use-immer';

function BackgroundCheckResultPage() {
	const navigate = useNavigate();
	const { state } = useNavigation();
	const { uuid } = useParams() as { uuid: string };
	const { data: html, isLoading } = useBackgroundReportHTML(uuid);
	const [downloading, setDownloading] = useImmer(false);
	if (state === 'loading') return <Loading />;
	return (
		<>
			<Stack
				direction='row'
				justifyContent='space-between'
				className='mt-16 md:mt-auto'
			>
				<Button
					variant='text'
					className='h-50 ml-[-15px]'
					onClick={() => navigate('../', { relative: 'path', replace: true })}
				>
					<ChevronLeftIcon />
					Back
				</Button>
				{
					<LoadingButton
						loading={downloading}
						variant='contained'
						color='secondary'
						onClick={() => {
							setDownloading(true);
							getReport(uuid).then(pdf => {
								downloadPDF(pdf, uuid);
								setDownloading(false);
							});
						}}
					>
						Download PDF
					</LoadingButton>
				}
			</Stack>
			<h3>Report</h3>
			<Divider variant='fullWidth' />
			{isLoading ? (
				<Loading />
			) : (
				html && <Box dangerouslySetInnerHTML={{ __html: html }} />
			)}
		</>
	);
}

const memoBackgroundCheckResultPage = React.memo(BackgroundCheckResultPage);
memoBackgroundCheckResultPage.displayName = 'BackgroundCheckResult';
export default memoBackgroundCheckResultPage;
